import api from './APIService';

class RegisteredParticipantsService {
    getListRegisteredParticipants(eventId) {
		return api.fetch({ method: 'get', path: '/livelaps/event/registrants/' + eventId });
	}
	findEvents(data) {
		return api.fetch({ method: 'post', path:'/livelaps/event/find', data });
	}
}

export default new RegisteredParticipantsService();
